import { render, staticRenderFns } from "./dataCenterRisk.vue?vue&type=template&id=530ca07b&scoped=true"
import script from "./dataCenterRisk.vue?vue&type=script&lang=js"
export * from "./dataCenterRisk.vue?vue&type=script&lang=js"
import style0 from "./dataCenterRisk.vue?vue&type=style&index=0&id=530ca07b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530ca07b",
  null
  
)

export default component.exports